// 组件类
import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { TranslationService } from "../../service/translation.service";
import { getTranslation } from "../../utils/utils";
@Component({
  selector: "rs-header",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class RSHeaderComponent implements OnInit {
  constructor(public translationService: TranslationService) {}

  @Input() isCollapsed: boolean = false; // 接收输入属性

  @Input() lastLoginTime = new Date();
  @Input() appName = "";

  @Input()
  set langOptions(options: any[]) {
    this._langOptions = options;
    if (options && options.length > 0) {
      const languageCode = localStorage.getItem("language") || "en";
      this.currentLang = options.find((e) => e.languageCode === languageCode);
    }
  }

  get langOptions(): any[] {
    return this._langOptions;
  }

  @Output()
  toggleMenu = new EventEmitter();

  @Output()
  changeLanguage = new EventEmitter();

  private _langOptions = [];

  currentLang: any;
  public translation;

  ngOnInit() {
    this.translation = getTranslation();
  }

  onToggleMenu(isCollapsed?: boolean) {
    const collapseState =
      isCollapsed !== undefined ? isCollapsed : !this.isCollapsed;
    this.toggleMenu.emit(collapseState);
  }

  selectLanguage(event) {
    this.currentLang = this.langOptions.find(
      (item) => item.text === event.item.text
    );
    this.changeLanguage.emit(this.currentLang.languageCode);
  }
}
